export const getNewsData = (news) => {
  return {
    title: news.news_title || ``,
    link: news.news_link || ``,
    imgSrc: news.news_image || ``,
    date: news.news_dt,
    content: news.news_text || ``,
  };
};
